import { Component, Input, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { AssessmentService } from 'src/app/services/assessment.service';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-funding-tab',
  templateUrl: './funding-tab.component.html',
  styleUrl: './funding-tab.component.scss',
  standalone: false
})
export class FundingTabComponent implements OnInit {
  //data
  @Input() assessment: any;
  @Input() reports: any;
  filtered_reports: any;
  hide_footer = false;

  total_req = 0;
  total_ro_auth = 0;
  total_wo_auth = 0;
  total_auth = 0;

  displayedColumns = [
    'name',
    'action_type',
    'report_type',
    'total_req',
    'ro_auth',
    'wo_auth',
    'total_auth',
    'auth_status',
    'date_auth'
  ];

  constructor(
    private readonly titleService: Title
  ) {
    this.titleService.setTitle("BAER - 2500-8 Funding")
  }

  ngOnInit(): void {
    this.titleService.setTitle(`BAER - ${this.assessment.baer_name} 2500-8 Funding`);
    this.filtered_reports = this.reports.filter((report: any) => report.authorization_status_id != null);
    if(this.filtered_reports.length == 0) this.hide_footer = true;
    this.calcTotals();
  }

  calcTotals() {
    this.filtered_reports.forEach((report: any) => {
      this.calcReportTotals(report);
      this.total_req += report.total_req;
      this.total_ro_auth += report.total_ro_auth;
      this.total_wo_auth += report.total_wo_auth;
      this.total_auth += report.total_auth;
    })
  }

  calcReportTotals(report: any) {
    let total_req = 0;
    let total_ro_auth = 0;
    let total_wo_auth = 0;
    let total_auth = 0;
    if (report.forests) {
      report.forests.forEach((forest: any) => {
        if (forest.treatments) {
          forest.treatments.forEach((treatment: any) => {
            let spec = treatment.treatment_specifications[0];
            if (spec) {
              total_req += ((spec.gis_unit_qty ?? spec.custom_unit_qty) ?? 0) * (spec.unit_cost ?? 0);
              total_ro_auth += ((spec.approved_unit_qty ?? 0) * (spec.approved_unit_cost ?? 0));
              total_wo_auth += ((spec.wo_approved_unit_qty ?? 0) * (spec.wo_approved_unit_cost ?? 0));
            }
          });
        }
      });
    }
    report.total_req = total_req;
    report.total_ro_auth = total_ro_auth;
    report.total_wo_auth = total_wo_auth;
    report.total_auth = total_ro_auth + total_wo_auth;
  }
}
